module.exports = __webpack_public_path__ + "img/qc.6078b1d6.png";